import { render, staticRenderFns } from "./IndexPersonal.vue?vue&type=template&id=6b3ee276&"
import script from "./IndexPersonal.vue?vue&type=script&lang=js&"
export * from "./IndexPersonal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports